// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/disorientation-coping.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/disorientation-coping/disorientation-coping.js';

mount([g0]);
